import { IconProps } from "./types";

export const ArrowIcon: React.FC<IconProps> = ({ uuid, fillColor }) => {
  return (
    <svg
      id={`arrow-icon-${uuid}`}
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
    >
      <path
        id={`arrow-icon-path-${uuid}`}
        d="M12.4999 16.3C12.1999 16.3 11.9999 16.3 11.7999 16L6.1999 10.4C5.7999 9.99995 5.7999 9.39995 6.1999 8.99995C6.5999 8.59995 7.1999 8.59995 7.5999 8.99995L12.4999 13.9L17.3999 8.99995C17.7999 8.59995 18.3999 8.59995 18.7999 8.99995C19.1999 9.39995 19.1999 9.99995 18.7999 10.4L13.1999 16C12.9999 16.2 12.6999 16.3 12.4999 16.3Z"
        fill={fillColor ?? "#333333"}
      />
    </svg>
  );
};
